import { render, staticRenderFns } from "./err401.vue?vue&type=template&id=278a0882&scoped=true&"
import script from "./err401.vue?vue&type=script&lang=js&"
export * from "./err401.vue?vue&type=script&lang=js&"
import style0 from "./err401.vue?vue&type=style&index=0&id=278a0882&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278a0882",
  null
  
)

export default component.exports